import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaEnvelope, FaTrash, FaCopy } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminNewsletter = () => {
  const [subscribers, setSubscribers] = useState([]);
  
  

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
    const res = await api.get('/Newsletter', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubscribers(res.data);
    } catch (err) {
      console.error("Error fetching subscribers", err);
    }
  };

  const deleteSubscriber = async (id) => {
    if(!window.confirm("Delete this email?")) return;
    try {
      const token = localStorage.getItem('token');
     await api.delete(`/Newsletter/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchData();
    } catch (err) {
      alert("Error deleting");
    }
  };

  const copyEmails = () => {
    const emails = subscribers.map(s => s.email).join(', ');
    navigator.clipboard.writeText(emails);
    alert("All emails copied to clipboard!");
  };

  return (
    <div className={styles.formCard} style={{ maxWidth: '800px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ color: '#4ade80', margin: 0 }}><FaEnvelope /> Subscribers ({subscribers.length})</h3>
        <button onClick={copyEmails} className={styles.primaryBtn} style={{ fontSize: '0.9rem' }}>
          <FaCopy /> Copy All Emails
        </button>
      </div>

      <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', color: 'white' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #444', textAlign: 'left' }}>
              <th style={{ padding: '10px' }}>Email</th>
              <th style={{ padding: '10px' }}>Date</th>
              <th style={{ padding: '10px', textAlign: 'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {subscribers.map((sub) => (
              <tr key={sub.id} style={{ borderBottom: '1px solid #333' }}>
                <td style={{ padding: '10px' }}>{sub.email}</td>
                <td style={{ padding: '10px', color: '#888', fontSize: '0.9rem' }}>
                  {new Date(sub.subscribedAt).toLocaleDateString()}
                </td>
                <td style={{ padding: '10px', textAlign: 'right' }}>
                  <button 
                    onClick={() => deleteSubscriber(sub.id)} 
                    style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
            {subscribers.length === 0 && (
              <tr>
                <td colSpan="3" style={{ padding: '20px', textAlign: 'center', color: '#888' }}>No subscribers yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminNewsletter;